import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {AppearanceSettings} from '@github-ui/appearance-settings-dialog'

registerReactPartial('appearance-settings', {
  Component: AppearanceSettings,
})
